import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { SecondaryTab } from 'components/Tabs';
import Groups from '../Groups/Groups';
import Main from '../Main/Main';
import Losers from '../Losers/Losers';
import Files from '../Files/Files';
import Tournament from '../Tournament/Tournament';
import Notifications from '../Notifications/Notifications';
import MiniLosers from '../MiniLosers/MiniLosers';
import Emails from '../Emails/Emails';

const ContentView = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState('notifications');

  return (
    <Box
      width={'100%'}
      height={'100%'}
      display={'flex'}
      flexDirection={'column'}
    >
      <Box maxWidth={{ xs: '100%', sm: '100%', md: '516px' }} width={'100%'}>
        <Typography
          variant="h4"
          color={theme.palette.darkGrey[700]}
          sx={{ fontWeight: 700, marginBottom: '16px' }}
        >
          Admin nustatymai
        </Typography>
        <Typography variant="body1" color={theme.palette.darkGrey[600]}>
          Čia galite valdyti turnyro grupių skirstymą, pagrindo ir paguodos
          lenteles, bei suskirstyti turnyro mačus, parsisiųsti vartotojų bei
          turnyro dalyvių sąrašus.
        </Typography>
      </Box>
      <Box
        marginTop={{ xs: '24px', sm: '40px' }}
        marginBottom={{ xs: '24px', sm: '32px' }}
      >
        <Box
          display={'flex'}
          alignItems={'stretch'}
          width={'100%'}
          sx={{
            borderBottom: {
              xs: 'none',
              sm: `1px solid ${theme.palette.darkGrey[300]}`,
            },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: '8px', sm: '8px' },
            flexWrap: { xs: 'nowrap', sm: 'wrap' },
            overflowX: { xs: 'auto', sm: 'visible' },
            justifyContent: { xs: 'stretch', sm: 'flex-start' },
            '&::-webkit-scrollbar': {
              height: '6px',
            },
            '&::-webkit-scrollbar-track': {
              background: theme.palette.grey[100],
              borderRadius: '3px',
            },
            '&::-webkit-scrollbar-thumb': {
              background: theme.palette.grey[400],
              borderRadius: '3px',
              '&:hover': {
                background: theme.palette.grey[500],
              },
            },
            '& > div': {
              flex: { xs: '0 0 auto', sm: '0 0 calc(25% - 6px)' },
              minWidth: { xs: '100%', sm: 'auto' },
              maxWidth: { xs: '100%', sm: 'calc(25% - 6px)' },
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                backgroundColor: theme.palette.grey[50],
                transform: 'translateY(-1px)',
              },
              '&:hover:not([style*="FCEEEB"])': {
                borderBottom: `2px solid ${theme.palette.grey[300]}`,
              },
            },
          }}
        >
          <SecondaryTab
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabName={'notifications'}
          />
          <SecondaryTab
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabName={'turnyras'}
          />
          <SecondaryTab
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabName={'grupės'}
          />
          <SecondaryTab
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabName={'pagrindas'}
          />
          <SecondaryTab
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabName={'paguoda'}
          />
          <SecondaryTab
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabName={'paguoda-Mini'}
          />
          <SecondaryTab
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabName={'failai'}
          />
          <SecondaryTab
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            tabName={'emails'}
          />
        </Box>
      </Box>
      <Box>
        {activeTab === 'notifications' && <Notifications />}
        {activeTab === 'turnyras' && <Tournament />}
        {activeTab === 'grupės' && <Groups />}
        {activeTab === 'pagrindas' && <Main />}
        {activeTab === 'paguoda' && <Losers />}
        {activeTab === 'paguoda-Mini' && <MiniLosers />}
        {activeTab === 'failai' && <Files />}
        {activeTab === 'emails' && <Emails />}
      </Box>
    </Box>
  );
};

export default ContentView;
